<div class="container">
  <section class="main">
    <header class="header">
      <mat-icon>donut_large</mat-icon><span>AI Sales Coach</span>
    </header>
    <div class="content">
      <h1>二要素認証の方法を選択</h1>
      @for (hint of hints; track hint.uid) {
        <button rectangle [disabled]="busy" (click)="select(hint.uid)">
          {{ hint.factorId === 'phone' ? 'SMS' : '認証アプリ' }}
          @if (hint.factorId === 'phone') {
            {{ phoneNumber(hint) }}
          }
        </button>
      }
      @if (errorMessage) {
        <p role="alert">{{ errorMessage }}</p>
      }
      <div id="recaptcha-container-id"></div>
      <button
        rectangle
        variant="secondary"
        [disabled]="busy"
        (click)="backToLogin()"
      >
        ログインへ戻る
      </button>
    </div>
  </section>
</div>
